import React from 'react';

// Importez les images que vous souhaitez utiliser
import imageCommentEmprunter from '../../images/LudoBlue/Gemini_Generated_Image_jmw3dkjmw3dkjmw3.png';
import imageCarteCadeau from '../../images/LudoBlue/Gemini_Generated_Image_e0of4qe0of4qe0of.png';

import { useLocation } from "react-router-dom";
import { useEffect } from "react";

function ScrollToAnchor() {
  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      const element = document.getElementById(id);
      if (element) element.scrollIntoView({ behavior: "smooth" });
    }
  }, [location]);
  return null;
}

const PretJeux = () => {
    return (
        
        <div className="container my-5">
<ScrollToAnchor />
            {/* Section 1: Offres Particuliers et Collectivités */}
            <div className="row" id="tarifs">
                {/* Colonne Particuliers */}
                <div className="col-lg-6 mb-4">
                    <div className="card h-100 shadow-sm">
                        <div className="card-header bg-primary text-white">
                            <h3 className="mb-0">Offres pour les Particuliers et Familles</h3>
                        </div>
                        <div className="card-body">
                            <p className="card-text">Redécouvrez le plaisir de jouer en famille ou entre amis ! LudoBlue vous propose des formules simples et accessibles.</p>
                            
                            <h5 className="mt-4">L'adhésion annuelle :</h5>
                            <ul>
                                <li><strong>Adhésion Individuelle :</strong> 15€ / an</li>
                                <li><strong>Adhésion Famille (même foyer) :</strong> 25€ / an</li>
                            </ul>

                            <h5 className="mt-4">Le prêt de jeux (pour 3 semaines) :</h5>
                            <ul>
                                <li><strong>Petits jeux :</strong> 1€</li>
                                <li><strong>Jeux de société classiques :</strong> 2€</li>
                                <li><strong>Gros jeux / Nouveautés :</strong> 3€</li>
                            </ul>
                            <p className="small text-muted">Chaque membre peut emprunter jusqu'à 3 jeux simultanément.</p>

                            <h5 className="mt-4">Jeu sur place :</h5>
                            <p>Profitez de notre espace pour jouer sur place gratuitement aux heures d'ouverture.</p>
                        </div>
                    </div>
                </div>

                {/* Colonne Collectivités */}
                <div className="col-lg-6 mb-4" >
                    <div className="card h-100 shadow-sm">
                        <div className="card-header bg-success text-white">
                            <h3 className="mb-0">Offres pour les Collectivités et Professionnels</h3>
                        </div>
                        <div className="card-body">
                             <p className="card-text">Le partenaire ludique des écoles, crèches, centres de loisirs, EHPAD, entreprises...</p>

                            <h5 className="mt-4">Location de malles de jeux thématiques :</h5>
                            <p>Des malles "clés en main" (Coopération, Moyen-Âge, etc.) contenant 5 à 10 jeux. Location au mois ou au trimestre.</p>
                            
                            <h5 className="mt-4">Animations sur site :</h5>
                            <p>Un ludothécaire se déplace dans votre structure avec une sélection de jeux pour animer vos événements.</p>
                            
                            <h5 className="mt-4">Aménagement de coins jeux :</h5>
                            <p>Nous vous conseillons dans le choix des jeux et du mobilier pour créer un coin ludique attractif.</p>
                        </div>
                        <div className="card-footer text-center">
                            <strong>Contactez-nous pour un devis personnalisé !</strong>
                        </div>
                    </div>
                </div>
            </div>

            <hr className="my-5" />

            {/* Section 2: Comment emprunter ? */}
            <div className="row align-items-center" id='comment-emprunter'>
                <div className="col-md-6 mb-4 mb-md-0">
                    <img src={imageCommentEmprunter} alt="Ludothèque avec des enfants qui jouent" className="img-fluid rounded shadow"/>
                </div>
                <div className="col-md-6">
                    <h2 className="mb-3">Comment emprunter des jeux ?</h2>
                    <p>Notre collection compte plus de 800 jeux. Emprunter, c'est simple comme un coup de dé !</p>
                    <ol className="list-group list-group-numbered">
                        <li className="list-group-item"><strong>Adhérez à l'association :</strong> L'adhésion est nécessaire pour pouvoir emprunter.</li>
                        <li className="list-group-item"><strong>Choisissez vos jeux :</strong> Explorez nos étagères ou demandez conseil à notre équipe.</li>
                        <li className="list-group-item"><strong>Enregistrez votre prêt :</strong> Nous enregistrons les jeux sur votre carte de membre pour 3 semaines.</li>
                        <li className="list-group-item"><strong>Jouez, jouez, jouez !</strong> Profitez de vos jeux à la maison.</li>
                        <li className="list-group-item"><strong>Retournez les jeux :</strong> Merci de rapporter les jeux complets et à temps pour les autres joueurs.</li>
                    </ol>
                </div>
            </div>

            <hr className="my-5" />

            {/* Section 3: Carte Cadeau */}
            <div className="row align-items-center" id='carte-cadeau'>
                <div className="col-md-6 order-md-2 mb-4 mb-md-0">
                    <img src={imageCarteCadeau} alt="Amis jouant à un jeu de société" className="img-fluid rounded shadow"/>
                </div>
                <div className="col-md-6 order-md-1">
                    <h2 className="mb-3">Offrez du jeu en cadeau !</h2>
                    <p>Vous cherchez une idée de cadeau originale, durable et qui crée du lien ? Pensez à la <strong>carte cadeau LudoBlue !</strong></p>
                    <p>Vous n'offrez pas un simple objet, mais des dizaines de possibilités de jeu et de moments de partage.</p>
                    <h5 className="mt-4">Comment ça marche ?</h5>
                    <p>Choisissez un montant, et la personne à qui vous l'offrez pourra utiliser ce crédit pour :</p>
                    <ul>
                        <li>Payer son adhésion annuelle.</li>
                        <li>Régler la location de jeux.</li>
                        <li>S'inscrire à nos événements payants.</li>
                    </ul>
                    <p className="fw-bold">Nos cartes cadeaux sont disponibles directement à l'accueil de la ludothèque.</p>
                </div>
            </div>
            
        </div>
    );
};

export default PretJeux;